module.exports = __webpack_public_path__ + "img/icon3.5ccba014.png";